import {
  START_LOADING,
  END_LOADING,
  FETCH_INVENTORY_TRANSACTIONS,
  FETCH_INVENTORY_TRANSACTION,
  CREATE_INVENTORY_TRANSFER
} from "../actions/constants";

const initialState = {
  isLoading: false,
  inventoryTransactions: [],
  inventoryTransaction: null,
  currentPage: 1,
  numberOfPages: 1
};

const inventoryTransactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_INVENTORY_TRANSACTIONS:
      return {
        ...state,
        inventoryTransactions: action.payload.inventoryTransactions,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages
      };
    
    case FETCH_INVENTORY_TRANSACTION:
      return {
        ...state,
        inventoryTransaction: action.payload
      };
    
    case CREATE_INVENTORY_TRANSFER:
      return {
        ...state,
        inventoryTransactions: [...state.inventoryTransactions, action.payload]
      };
    
    default:
      return state;
  }
};

export default inventoryTransactionsReducer;
